import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReactNode } from 'react';
import { UseSelectBasicObject } from '../../types/UseSelectBasicObject';
import './ModalGlobal.css';
import { ModalType } from '../../hooks/useModal';
import ModalContent from './ModalContent';


// Props for the main modal
type ModalGlobalProps<T> = {
    show: boolean;
    onClose: () => void;
    title?: string;
    body?: ReactNode;
    onSave?: () => void;
    onCancel?: () => void;
    saveText?: string;
    closeText?: string;
    className?: string;
    loadingText?: string;
    isLoading: boolean;
    contentType?: ModalType;
    subtitle?: string;
    subtitle2?: string;
    countValues?: number;
    error?: string;
    endDate?: Date | null;
    onEndDateChange?: (date: Date | null) => void
    startDate?: Date | null;
    onStartDateChange?: (date: Date | null) => void
    handleFileChange?: (file: File | null) => void;
    handleSelectChange?: (value: string) => void;
    handleMotiveDeleteChange?: (value: string) => void;
    optionsMap?: T[]; // Add optionsMap here
    handleAlertsPerson?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleSelectAllChange?: (checked: boolean) => void;
    showOptions?: boolean;
    selectedOptions?: string[];
    size?: "xs" | "sm" | "lg" | "xl";
    dialogClassName?: string;
};

export default function ModalGlobal <T extends UseSelectBasicObject>({
    show,
    onClose,
    title = "",
    body = "Contenido del Modal",
    onSave,
    onCancel,
    saveText = "Guardar cambios",
    closeText = "Cerrar",
    className,
    contentType,
    subtitle,
    subtitle2,
    countValues,
    error,
    endDate,
    startDate,
    onEndDateChange,
    onStartDateChange,
    handleFileChange,
    handleSelectChange,
    handleMotiveDeleteChange,
    isLoading,
    optionsMap,
    handleCheckboxChange,
    handleSelectAllChange,
    handleAlertsPerson,
    showOptions,
    selectedOptions,
    size,
    dialogClassName
}: ModalGlobalProps<T>) {
    const modalSize = size === "xs" ? undefined : size; 
    const modalDialogClassName = [
        dialogClassName,
        size === "xs" ? "modal-xs" : null,
    ].filter(Boolean).join(" ");

    const renderBodyContent = () => {
        if (contentType) {
            return (
                <ModalContent
                    type={contentType}
                    subtitle={subtitle}
                    subtitle2={subtitle2}
                    error={error}
                    endDate={endDate}
                    onEndDateChange={onEndDateChange}
                    handleFileChange={handleFileChange}
                    handleSelectChange={handleSelectChange}
                    optionsMap={optionsMap}
                    countValues={countValues}
                    handleMotiveDeleteChange={handleMotiveDeleteChange}
                    startDate={startDate}
                    onStartDateChange={onStartDateChange}
                    handleAlertsPerson={handleAlertsPerson}
                    handleCheckboxChange={handleCheckboxChange}
                    handleSelectAllChange={handleSelectAllChange}
                    showOptions={showOptions}
                    selectedOptions={selectedOptions}
                />
            );
        }
        return body;
    };

    return (
        <>
            
            <Modal
                show={show}
                onHide={onClose}
                className={className}
                dialogClassName={modalDialogClassName || undefined}
                size={modalSize}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderBodyContent()}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel ? onCancel : onClose } disabled={isLoading}>
                        {closeText}
                    </Button>
                    {onSave && (
                        <Button variant="primary" onClick={onSave} disabled={isLoading}>
                            {saveText}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
}
